// extracted by mini-css-extract-plugin
export var orderSummary = "_ub-0";
export var showMoreLessButton = "_ub-1";